import { Injectable } from '@angular/core';
import { NzModalService, OnClickCallback } from 'ng-zorro-antd/modal';
import { GainsConfirmOptions } from 'app/shared/models/gains-confirm-options.model';

@Injectable({
  providedIn: 'root'
})
export class GainsApplyCancelService {
  constructor(private readonly _modalService: NzModalService) {}

  apply(title: string, content: string, onOk: OnClickCallback<any>, onCancel?: OnClickCallback<any>): void {
    return this._create('apply', title, content, onOk, onCancel);
  }

  delete(title: string, content: string, onOk: OnClickCallback<any>, onCancel?: OnClickCallback<any>): void {
    return this._create('delete', title, content, onOk, onCancel);
  }

  deactivate(title: string, content: string, onOk: OnClickCallback<any>, onCancel?: OnClickCallback<any>): void {
    return this._create('deactivate', title, content, onOk, onCancel);
  }

  confirm({ title, content, okText, cancelText, danger = false, onOk, onCancel }: GainsConfirmOptions): void {
    this._modalService.create({
      nzTitle: title,
      nzContent: content,
      nzClassName: 'custom-rounded-modal',
      nzOkText: okText,
      nzCancelText: cancelText,
      nzOkDanger: danger,
      nzOnOk: onOk,
      nzOnCancel: onCancel ?? (() => undefined),
      nzWidth: '384px',
      nzCentered: true
    });
  }

  _create(type: 'apply' | 'delete' | 'deactivate' | string, title: string, content: string, onOk?: OnClickCallback<any>, onCancel?: OnClickCallback<any>): void {
    let okText = '';
    let className = 'custom-rounded-modal';
    switch (type) {
      case 'apply':
        okText = 'Apply';
        className += ' apply-modal';
        break;
      case 'delete':
        okText = 'Delete';
        className += ' delete-modal';
        break;
      case 'deactivate':
        okText = 'Deactivate';
        className += ' apply-modal';
        break;
      default:
        okText = 'Ok';
    }

    this._modalService.create({
      nzTitle: title,
      nzContent: content,
      nzClassName: className,
      nzOkText: okText,
      nzOkDanger: type === 'delete' ? true : false,
      nzOnOk: onOk,
      nzWidth: '384px',
      nzCentered: true,
      nzOnCancel: onCancel
        ? onCancel
        : () => {
            // Do nothing
          }
    });
  }
}
